/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const bulkCandidateWhatsAppDataSchema = z.object({
	campaignId: z.string(),
	candidateIds: z.array(z.string()),
	templateId: z.string(),
	parameters: z.array(z.string()).nullable().optional().default([]),
})

export type BulkCandidateWhatsAppDataSchema = z.infer<typeof bulkCandidateWhatsAppDataSchema>
